import { Monitor, Moon, Sun } from 'lucide-react'
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  Label,
  Page,
  ToggleGroup,
  ToggleGroupItem,
} from '@rammetec/design-system'
import {
  useThemePreference,
  useUserPreferences,
  type AppDensity,
  type AppLanguage,
  type ThemePreference,
} from '@vectorhub/application'

export function SettingsPage() {
  const { mode, setMode } = useThemePreference()
  const { language, density, setLanguage, setDensity } = useUserPreferences()

  return (
    <Page
      name="vectorhub.settings"
      title="Configurações"
      description="Preferências de aparência e idioma."
      productArea="vectorhub"
    >
      <Card className="max-w-2xl">
        <CardHeader>
          <CardTitle>Aparência</CardTitle>
          <CardDescription>Escolha o tema e a densidade da interface.</CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="space-y-3">
            <Label>Tema</Label>
            <ToggleGroup
              type="single"
              value={mode}
              onValueChange={(next: string) => {
                if (next) setMode(next as ThemePreference)
              }}
              variant="outline"
              aria-label="Tema"
            >
              <ToggleGroupItem value="light">
                <Sun className="h-4 w-4" />
                Claro
              </ToggleGroupItem>
              <ToggleGroupItem value="dark">
                <Moon className="h-4 w-4" />
                Escuro
              </ToggleGroupItem>
              <ToggleGroupItem value="auto">
                <Monitor className="h-4 w-4" />
                Sistema
              </ToggleGroupItem>
            </ToggleGroup>
          </div>
          <div className="space-y-3">
            <Label>Densidade</Label>
            <ToggleGroup
              type="single"
              value={density}
              onValueChange={(next: string) => {
                if (next) setDensity(next as AppDensity)
              }}
              variant="outline"
              aria-label="Densidade"
            >
              <ToggleGroupItem value="comfortable">Confortável</ToggleGroupItem>
              <ToggleGroupItem value="compact">Compacto</ToggleGroupItem>
            </ToggleGroup>
          </div>
        </CardContent>
      </Card>

      <Card className="max-w-2xl">
        <CardHeader>
          <CardTitle>Idioma</CardTitle>
          <CardDescription>Selecione o idioma da interface.</CardDescription>
        </CardHeader>
        <CardContent>
          <ToggleGroup
            type="single"
            value={language}
            onValueChange={(next: string) => {
              if (next) setLanguage(next as AppLanguage)
            }}
            variant="outline"
            aria-label="Idioma"
          >
            <ToggleGroupItem value="pt-BR">Português (Brasil)</ToggleGroupItem>
            <ToggleGroupItem value="en-US">English</ToggleGroupItem>
          </ToggleGroup>
        </CardContent>
      </Card>
    </Page>
  )
}
